import { FormResource } from "../locales";

export const form: FormResource = {
    rangeOverflow: "Arvo ei saa olla suurempi kuin {{max}}.",
    rangeUnderflow: "Arvo ei saa olla pienempi kuin {{min}}.",
    required: "Pakollinen kenttä.",
    invalidEmail: "Virheellinen sähköpostiosoite.",
};
